var map = {
	"./00.mp3": "c077",
	"./01.mp3": "ae91",
	"./02.mp3": "3be2",
	"./03.mp3": "1e4a",
	"./04.mp3": "7ec2",
	"./05.mp3": "16ed",
	"./06.mp3": "6287",
	"./07.mp3": "4295",
	"./08.mp3": "8450",
	"./09.mp3": "213e",
	"./10.mp3": "1c7d",
	"./11.mp3": "c7c2",
	"./12.mp3": "c490",
	"./13.mp3": "d90a",
	"./14.mp3": "fc6a",
	"./M_Brilliant.mp3": "e42d",
	"./M_Excellent.mp3": "fbda",
	"./M_Fantastic.mp3": "fd81",
	"./M_Great.mp3": "382d",
	"./M_Perfect.mp3": "dbbe",
	"./M_Think again.mp3": "08f0",
	"./M_Try again.mp3": "6b0a",
	"./M_Very good.mp3": "e2ef",
	"./M_Well done.mp3": "9355",
	"./M_Work harder.mp3": "41c5",
	"./click.mp3": "7e2b",
	"./false.mp3": "1b92",
	"./true.mp3": "8353"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f106";